import Header from "@/types/app/header";

export default class CustomerAccount {
  public static header: Header[] = [
    {
      text: "Create date",
      align: "start",
      sortable: true,
      value: "entryDateTime",
      class: "item-table-header item-table-header-entryDateTime",
      width: ""
    },  
    {
      text: "Email",
      align: "start",
      sortable: true,
      value: "email",
      class: "item-table-header item-table-header-name",
      width: ""
    },  
    {
      text: "Investor Name",
      align: "start",
      sortable: true,
      value: "investorName",
      class: "item-table-header item-table-header-name",
      width: ""
    },
    {
      text: "Account Number",
      align: "start",
      sortable: true,
      value: "accountNumber",
      class: "item-table-header item-table-header-description",
      width: ""
    },    
    {
      text: "Fund Name",
      align: "start",
      sortable: true,
      value: "fundName",
      class: "item-table-header item-table-header-fundId",
      width: ""
    },
    {
      text: "Returned Api",
      align: "start",
      sortable: true,
      value: "returnedInWallet",
      class: "item-table-header item-table-header-fundId",
      width: ""
    },
    {
      text: "",
      align: "right",
      value: "actions",
      sortable: false,
      class: null,
      width: ""
    }
  ];
}
